/* import __COLOCATED_TEMPLATE__ from './attribute-item.hbs'; */
/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file: 🚀 */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-classic-components */
/* eslint-disable @intercom/intercom/require-empty-tagname */
import { notEmpty, and } from '@ember/object/computed';
import Component from '@ember/component';
export default Component.extend({
  tagName: '',
  hasAttributeDisabledTooltipContent: notEmpty('context.attributeDisabledTooltipContent'),
  showAttributeDisabledTooltip: and('attribute.isDisabled', 'hasAttributeDisabledTooltipContent')
});